// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__qo4dp","form":"styles_form__DqbJk","loginForm":"styles_loginForm__ikFpX","formImage":"styles_formImage__xs_uz"};
module.exports.__checksum = "40c1ec6fcf1b"